<template>
    <div @contextmenu.prevent @dragstart.prevent @copy.prevent @selectstart.prevent translate="no">
        <paperlayout>
            <div class="exam" :style="`height:${windowHeight}px`">
                <div class="exam_title">
                    <span class="label_title">{{ parentMessage }}</span>
                    
                    <div style="float: right;font-size: 18px;font-weight: 700;color: #f56c6c;">
                        <span>倒计时: </span>
                        <span>{{ downTime }}</span>
                        <span @click="updateTim" style="font-size: 25px;margin-left: 5px;float: right;color: #409EFF;cursor: pointer;" class="el-icon-refresh"></span>
                    </div>
                </div>
                <el-divider></el-divider>

                <div class="type_box">
                    
                    <span class="trem" v-for="(item,index) in type_data" :key="index" :style="index == change_index?'background-color:#409eff;color:#ffffff':''">{{ item }}</span>
                    <!-- <div style="float: right;">
                        <span>完成/题目数量: </span>
                        <span>10/20</span>
                    </div> -->
                </div>
                <Choice ref="choice" v-if="[1,2,3,9].includes(change_index)" :nid="nid" :fraction_data="fraction_data" :type_data="type_data" :windowHeight="windowHeight" :question_type="change_index" :exam="exam_data" @updateQuestion="updateQuestion"></Choice>
                <Vacancy ref="vacancy" v-if="[4,5].includes(change_index)" :nid="nid" :fraction_data="fraction_data" :type_data="type_data" :windowHeight="windowHeight" :question_type="change_index" :exam="exam_data" @updateQuestion="updateQuestion"></Vacancy>
                <Write ref="write" v-if="[6,7].includes(change_index)" :nid="nid" :fraction_data="fraction_data" :type_data="type_data" :windowHeight="windowHeight" :question_type="change_index" :exam="exam_data" @updateQuestion="updateQuestion"></Write>
            </div>
        </paperlayout>
    </div>
</template>

<script>
import Choice from '../../units/examination/Choice';
import Vacancy from '../../units/examination/Vacancy';
import Write from '../../units/examination/Write';
import Http from "../../apis/student";
import Paperlayout from '../Paperlayout';
export default {
  components: { Paperlayout,Choice,Vacancy,Write },
    data(){
        return{
            trem:'',
            windowHeight:0,
            parentMessage:'',
            type_data:{},
            change_index:0,
            exam_data:{},
            downTime:'0 时 0 分 0 秒',
            fraction_data:{},
            plan_id:0,
            seconds:0,
            setIntervaltime:null,
            nid:''
        }
    },
    activated(){
        this.nid = this.$route.query.nid
        this.trem = this.$route.query.trem
        this.plan_id = this.$route.query.plan_id
        setTimeout(()=>{
            this.getExam()
        },200)
        
        
    },

    created(){
        //this.alertmessage()
    },
    mounted() {
        this.getWindowHeight();
        window.addEventListener('resize', this.getWindowHeight);
    },
    beforeDestroy() {

        clearInterval(this.setIntervaltime);
        window.removeEventListener('resize', this.getWindowHeight);
    },
    deactivated() {
        clearInterval(this.setIntervaltime);
        this.setIntervaltime = null;
    },
    methods:{
        updateQuestion(item){
            this.change_index = parseInt(item.nextQuestionType)
            setTimeout(()=>{

                
                //当前题型材料数量
                var number = (item.change_type?0:Object.keys(this.exam_data[this.change_index]).length - 1)

                if([1,2,3,9].includes(this.change_index)){
                    this.$refs.choice.set(item.currentIndex,number)
                }
                if([4,5].includes(this.change_index)){
                    this.$refs.vacancy.set(item.currentIndex,number)
                }

                if([6,7].includes(this.change_index)){
                    this.$refs.write.set(item.currentIndex,number)
                }

                
            },100)
            
        },
        // clickType(index){
        //     var currentIndex = 0
        //     this.change_index = parseInt(index)
        //     setTimeout(()=>{
                

        //         let type_data = Object.keys(this.type_data)

        //         for(var i in type_data){
        //             if(type_data[i] == index){
        //                 currentIndex = i
        //             }
        //         }
        //         console.log(index,currentIndex)
        //         var number = Object.keys(this.exam_data[this.change_index]).length - 1
    
        //         if([1,2,3,9].includes(this.change_index)){
        //             this.$refs.choice.set(currentIndex,number)
        //         }
        //         if([4,5].includes(this.change_index)){
        //             this.$refs.vacancy.set(currentIndex,number)
        //         }

        //         if([6,7].includes(this.change_index)){
        //             this.$refs.write.set(currentIndex,number)
        //         }
        //     },100)
            
        // },
        getWindowHeight() {

            this.windowHeight = parseInt(window.innerHeight - 180);
        },
        getExam(){
            this.change_index = 0
            var params = {}
            params.nid = this.nid
            params.trem = this.trem
            params.plan_id = this.plan_id
            Http.examination(params).then((res) => {
                const keys = Object.keys(res.data.type_data)
                this.change_index = parseInt(keys[0])

                this.parentMessage = res.data.title
                this.type_data = res.data.type_data
                this.exam_data = res.data.result
                this.fraction_data = res.data.fraction_data
                
                this.seconds = res.data.examtime
                this.startCountdown()
            });
        },
        startCountdown() {
            clearInterval(this.setIntervaltime);
            this.setIntervaltime = null;
            if (this.seconds > 0) {
                this.timeOute();
                this.setIntervaltime = setInterval(() => {
                    this.timeOute();
                }, 1000);
            }
        },


        updateTim(){
            var params = {}
            params.nid = this.nid
            Http.updateTime(params).then((res) => {
                this.seconds = res.data.examtime
                this.startCountdown()
                this.$message({
                    type:'success',
                    message:'时间已更新'
                })
            });
        },
        timeOute(){
            var seconds = this.seconds
            console.log(seconds)
			if(!seconds || seconds <= 0){

                clearInterval(this.setIntervaltime)
                this.setIntervaltime = null
                this.downTime = '考试结束'
				return false
			}

            if(seconds === 300) {
                this.$message({
                    type: 'error',
                    message: '考试即将结束，还剩5分钟，请尽快完成答题',
                    duration: 8000
                });
            }

            this.seconds--;

			let secondTime = parseInt(seconds)
			let min = 0
			let h =0
			let result=''
			if(secondTime>=60){
				min=parseInt(secondTime/60)
				secondTime=parseInt(secondTime%60)
				if(min>=60){
					h=parseInt(min/60)
					min=parseInt(min%60) 
				}
			}
			
		    if (h) {
		    		result=`${h.toString().padStart(2,'0')} 时 ${min.toString().padStart(2,'0')} 分 ${secondTime.toString().padStart(2,'0')} 秒`
		    } else if (min) {
				result=`${min.toString().padStart(2,'0')} 分 ${secondTime.toString().padStart(2,'0')} 秒`
		    } else {
				result=`${secondTime.toString().padStart(2,'0')} 秒`
		    }
    
			this.downTime = result
			
		},

    }
}
</script>
<style lang="less" scoped>
.exam_title{
    width: 100%;
    display: inline-block;
}
.label_title{
    float: left;
    text-indent: 10px;
    font-weight: 700;
}
.exam::v-deep .el-divider{
    margin: 15px 0;
}
.type_box{
    display: inline-block;
    width: 100%;
    box-sizing: border-box;
    padding:0 20px;

    .trem{
        color: #409EFF;
        background: #ecf5ff;
        border-color: #b3d8ff;
        padding: 9px 15px;
        font-size: 12px;
        border-radius: 3px;
        display: inline-block;
        margin-right: 10px;
        cursor: pointer;
        margin-bottom: 10px;
    }
}
@media (max-width: 768px) {
    .exam_title {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    .exam_title .label_title {
        margin-bottom: 10px;
    }

    .type_box .trem {
        padding: 6px 10px;
        font-size: 12px;
    }
    .exam {
        height: 100vh; /* 使用视口高度 */
        overflow-y: auto; /* 确保内容可以滚动 */
        -webkit-overflow-scrolling: touch; /* 启用iOS平滑滚动 */
    }
}
</style>